import React, { useState } from "react";



const images = [
  { url: "https://panchamidevi.in/images/img-1.jpg", category: "latest" },
  { url: "https://panchamidevi.in/images/img-2.jpg", category: "latest" },
  { url: "https://panchamidevi.in/images/img-3.jpg", category: "latest" },
  { url: "https://panchamidevi.in/images/img-4.jpg", category: "latest" },
  { url: "https://panchamidevi.in/images/img-5.jpg", category: "latest" },
  // { url: "https://spst.in/images/pic8.jpg", category: "lekshadeepam" },
  // { url: "https://spst.in/images/pic9.jpg", category: "lekshadeepam" },
  // { url: "https://spst.in/images/pic10.jpg", category: "lekshadeepam" },
  // { url: "https://spst.in/images/pic11.jpg", category: "lekshadeepam" },
  // { url: "https://spst.in/images/pic12.jpg", category: "lekshadeepam" },
];

function PhotoGallery() {
  
  const [filter, setFilter] = useState("all");

  const filteredImages =
    filter === "all"
      ? images
      : images.filter((img) => img.category === filter);

  return (
    
    <div>
       <div className="row banner" style={{backgroundImage:'url(./images/devi.png)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
        <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
            {/* Filter Buttons */}
      {/* <div style={{ marginBottom: "20px" }}>
        <button className="btn btn-secondary" onClick={() => setFilter("all")} style={{marginRight:'5px'}}>All</button>
        <button className="btn btn-secondary" onClick={() => setFilter("latest")} style={{marginRight:'5px'}}>Latest</button>
        <button className="btn btn-secondary" onClick={() => setFilter("vedic")} style={{marginRight:'5px'}}>Vedic Seminar</button>
        <button className="btn btn-secondary" onClick={() => setFilter("lekshadeepam")} style={{marginRight:'5px'}}>Lekshadeepam</button>
      </div> */}

      {/* Gallery Grid */}
      <div style={galleryStyle}>
        {filteredImages.map((img, index) => (
          <div key={index} style={itemStyle}>
            <img src={img.url} alt={img.category} style={imgStyle} />
          </div>
        ))}
      </div>
        </div>
      
      
    </div>
  );
}

const galleryStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
  gap: "15px",
};

const itemStyle = {
  borderRadius: "8px",
  overflow: "hidden",
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
};

const imgStyle = {
  width: "100%",
  height: "auto",
  transition: "transform 0.3s",
  cursor: "pointer",
};

export default PhotoGallery;
